import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchBar from "../Common/SearchBar";
import Pagination from "../Common/Pagination";
import SellerProjectsTable from "./SellerProjectsTable";
import BuyerProjectsTable from "./BuyerProjectsTable";
import AdminProjectsTable from "./AdminProjectsTable";
import { useProjectData } from "./useProjectData";
import MultiSelectFilter from "../Common/MultiSelectFilter";

export default function Projects({ userRole, viewType }) {
    const location = useLocation();
    const hasSetInitialFilter = useRef(false);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState(["All"]);
    const [perPage, setPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);

    const {
        loading,
        projects,
        totalPages,
        totalResults,
        availableStatuses,
        selectedRows,
        toggleAll,
        toggleRow,
    } = useProjectData(search, currentPage, perPage, statusFilter, viewType);


    // Apply filter from navigation state if provided (only once)
    useEffect(() => {
        if (location.state?.filterStatuses && !hasSetInitialFilter.current) {
            setStatusFilter(location.state.filterStatuses);
            hasSetInitialFilter.current = true;
            // Reset currentPage when filter changes from navigation
            setCurrentPage(1);
        }
    }, []);

    const statusOptions = ["All", ...availableStatuses];

    const getTitle = () => {
        if (viewType === 'contracts') return 'Contracts Overview';
        return 'Projects Overview';
    };

    const getSubtitle = () => {
        if (viewType === 'contracts') return 'Manage contracts from PO to tripartite agreement';
        return 'Track, manage, and execute projects with clarity and control';
    };

    return (
        <div className="mt-4 border rounded p-3">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
                <h4 className="fw-bold">{getTitle()}</h4>
            </div>

            <p className="text-muted mb-2">
                {getSubtitle()}
            </p>


            <div className="mt-4 border rounded p-3">

                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <h5 className="fw-bold">{ viewType === 'contracts' ? 'Contracts' : 'Projects'}</h5>
                    <div className="d-flex gap-2 flex-wrap">
                        <MultiSelectFilter
                            options={statusOptions}
                            selectedValues={statusFilter}
                            onChange={setStatusFilter}
                            label="Status"
                        />
                        <SearchBar
                            search={search}
                            setSearch={setSearch}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>
                </div>

                {/* Table */}
                {userRole === 'Seller' && <SellerProjectsTable
                    loading={loading}
                    data={projects}
                    currentPage={currentPage}
                    perPage={perPage}
                    selectedRows={selectedRows}
                    toggleRow={toggleRow}
                    toggleAll={toggleAll}
                />}

                {userRole === 'Buyer' && <BuyerProjectsTable
                    loading={loading}
                    data={projects}
                    currentPage={currentPage}
                    perPage={perPage}
                    selectedRows={selectedRows}
                    toggleRow={toggleRow}
                    toggleAll={toggleAll}
                />}

                {['Admin', 'Project Manager'].includes(userRole) && <AdminProjectsTable
                    loading={loading}
                    data={projects}
                    currentPage={currentPage}
                    perPage={perPage}
                    selectedRows={selectedRows}
                    toggleRow={toggleRow}
                    toggleAll={toggleAll}
                    userRole={userRole}
                    viewType={viewType}
                />}


                {/* Pagination */}
                <Pagination
                    perPage={perPage}
                    setPerPage={setPerPage}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalResults={totalResults}
                />
            </div>
        </div >
    );
}
